export default class ShopCartRecommendedProduct extends HTMLElement {
    private variantId: string
    private inCart: boolean

    private containerEl: HTMLElement | null = null
    private quantityInput: HTMLInputElement | null = null
    private addButton: HTMLButtonElement | null = null

    constructor() {
        super()

        this.inCart = this.getAttribute('data-in-cart') === 'true'

        // Get the variant ID from the element's id attribute
        this.variantId = this.id

        // Get the quantity input and add button
        this.quantityInput = this.querySelector('input[data-quantity]') as HTMLInputElement
        this.addButton = this.querySelector('button[data-button]') as HTMLButtonElement

        // Get the container element
        this.containerEl = this.querySelector('[data-container]') as HTMLElement

        if (this.containerEl && !this.inCart) {
            this.containerEl.classList.remove('hidden')
        }

        if (this.addButton) {
            this.addButton.addEventListener('click', this.handleAddToCart.bind(this))
        }

        // ;(window as any).addEventListener('cart:update', this.handleCartUpdate.bind(this))
    }

    private handleAddToCart(evt: Event) {
        evt.preventDefault()

        if (!this.variantId) {
            console.error('No variant ID found')
            return
        }

        // Get current quantity value
        const quantity = this.quantityInput ? parseInt(this.quantityInput.value) : 1

        // Prepare the request body for liquidAjaxCart.add()
        const body = {
            items: [
                {
                    id: this.variantId,
                    quantity: quantity,
                },
            ],
        }

        // Add to cart using liquidAjaxCart
        // @ts-ignore - liquidAjaxCart is added globally
        if (window?.liquidAjaxCart?.add) {
            // @ts-ignore
            window.liquidAjaxCart.add(body, {
                // Optional callbacks
                firstCallback: () => {
                    // Request is performed but cart is not updated yet
                    this.addButton?.setAttribute('disabled', 'true')
                },
                lastCallback: () => {
                    // Cart is updated
                    this.addButton?.removeAttribute('disabled')
                },
            })
        }
    }
}

customElements.define('shop-cart-recommended-product', ShopCartRecommendedProduct)
